var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-select',{staticClass:"appointment_type",attrs:{"disabled":_vm.disabled,"clearable":"","placeholder":"請選擇預約類型"},model:{value:(_vm.typeValue),callback:function ($$v) {_vm.typeValue=$$v},expression:"typeValue"}},_vm._l((_vm.typeList),function(e){return _c('el-option',{key:e.value,attrs:{"value":e.value,"label":e.text}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }